import { CodeTransactionTable } from './CodeTransactionTable'
import { withCodeTransactionTable } from './withCodeTransactionTable'

const ConnectedCodeTransactionTable =
  withCodeTransactionTable(CodeTransactionTable)
export { ConnectedCodeTransactionTable as CodeTransactionTable }
